import React, { ChangeEvent, forwardRef } from 'react';
import classNames from 'classnames';
import { pushGtmEvent } from 'services/gtm/gtmEvents';

// Create custom tab component to replace MUI Tab to H2 element
const CustomTabComponent = (
  {
    label,
    gtm_label,
    onChange,
    selected,
    className,
    selectedClassName,
    value,
    ...props
  }: {
    label: string;
    gtm_label: string;
    onChange?: (event: ChangeEvent, value: string) => void;
    selected?: boolean;
    className: string;
    selectedClassName: string;
    value?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  },
  ref
) => {
  const onClickHandler = event => {
    if (onChange) {
      onChange(event, value);
    }
  };

  // Remove tab component specific attributes
  for (const deleteAttribute of [
    'fullWidth',
    'textColor',
    'selectionFollowsFocus',
  ]) {
    if (props.hasOwnProperty(deleteAttribute)) {
      delete props[deleteAttribute];
    }
  }

  return (
    <h2
      aria-selected={selected}
      ref={ref}
      onClick={e => {
        onClickHandler(e);
        pushGtmEvent({
          event: '_click_other',
          category: 'clic autre - fiche produit',
          element: gtm_label,
        });
      }}
      className={classNames(className, {
        [selectedClassName]: selected,
      })}
      {...props}
    >
      {label}
    </h2>
  );
};

export const CustomTab = forwardRef(CustomTabComponent);
